import { Sim } from '../../game/simulation';

/**
 * Floating "Back to overview" pill — visible only while the camera is
 * diving on a 6×6 sector (zoom mode). Clicking it (or pressing ESC / RMB)
 * pulls the camera back out.
 */
export class ZoomExitButton {
  private root: HTMLButtonElement;

  constructor(parent: HTMLElement, private sim: Sim) {
    this.root = document.createElement('button');
    this.root.className = 'ui-zoom-exit';
    this.root.innerHTML = `<span>←</span> Back to overview <kbd>ESC</kbd>`;
    this.root.style.display = 'none';
    this.root.addEventListener('click', () => this.sim.exitZoom());
    parent.appendChild(this.root);

    sim.bus.on(e => {
      if (e.type === 'zoomEntered') this.root.style.display = '';
      else if (e.type === 'zoomExited') this.root.style.display = 'none';
    });
  }
}
